import React from 'react';
import { noResultConfig } from '../../../../DTInfoWidget/widgetConfig';
import { CustomNoResultsComponentContextProvider } from '../../Common/NoSearchResults/CustomNoResultsComponentContext';
import NoResultsComponent from '../../../../Common/DTNoResults/DTNoResults';
import { DTOrderSearchView } from '../../DTOrderSearchView';
import { useDispatch, useSelector } from 'react-redux';
import { hasLineItemsInOrderSelected } from '../../../../../../selectors/tools';
import { addEdgeToDecisionTreePath } from '../../../../../../actions/searchActions';

const DTSelectOrderAndLineItemsYetiCancelNode = () => {
  const dispatch = useDispatch();
  const hasLineItemsSelected = useSelector(hasLineItemsInOrderSelected);

  const handleNextButtonClick = () => {
    dispatch(addEdgeToDecisionTreePath('items_selected'));
  };

  return (
    <CustomNoResultsComponentContextProvider value={<NoResultsComponent {...noResultConfig.yeti} />}>
      <DTOrderSearchView onNextButtonClick={handleNextButtonClick} isNextButtonActive={hasLineItemsSelected} />
    </CustomNoResultsComponentContextProvider>
  );
};

export default DTSelectOrderAndLineItemsYetiCancelNode;
